import { Injectable } from "@angular/core";

import { RichTextEditorToolbar } from "../models";


@Injectable()
export class RichTextEditorToolbarService {

    public getDefaultToolbar(): RichTextEditorToolbar {
        return [
            ["bold", "italic", "underline", "strike"],       // font format
            ["blockquote"],                                  // quotes
            [{ "script": "sub" }, { "script": "super" }],    // superscript and subscript
            [{ "color": [] }, { "background": [] }],         // font and background colors
            ["clean"],                                       // remove formatting
            [{ "list": "ordered" }, { "list": "bullet" }],   // numbered and bullet list
            [{ "indent": "-1" }, { "indent": "+1" }],        // outdent and indent
            [{ "align": [] }],                               // text align
            [{ "direction": "rtl" }],                        // text direction
            ["link", "image"],                               // exclude "video" here
            [{ "font": [] }],                                // font style
            [{ "size": ["small", false, "large", "huge"] }], // font size
            [{ "header": [1, 2, 3, 4, 5, 6, false] }],       // header formats
        ];
    }
}